(function ($) {
    var _duration = 1000,
        _easing = "easeOutCubic",
        _width = window.innerWidth,
        _windowWidth = window.innerWidth,
        _windowHeight = window.innerHeight,
        _spmode = 768,
        _speed = 1000;
        _winScrollTop = 0;


    window.onload = function () {
        $('.home_slider, .new_arrival_slide, .recommend_prod_slide').on('init', function (event, slick) {
          $(this).removeClass('is_loading');
        });
        slickSlider('.home_slider', {
            slide: '.slide_item',
            fade: false,
            autoplay: true,
            arrows: true,
            dots: true,
            autoplaySpeed: 3000,
            adaptiveHeight: true,
            variableWidth: true,
            centerMode: true,
            slidesToShow: 1,
            prevArrow: $('#hero .btn_prev'),
            nextArrow: $('#hero .btn_next'),
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        centerPadding: '0',
                        variableWidth: false,
                    }
                }
              ]
        });
        slickSlider('.new_arrival_slide', {
            fade: false,
            autoplay: false,
            arrows: true,
            dots: false,
            autoplaySpeed: 3000,
            adaptiveHeight: true,
            variableWidth: true,
            slidesToShow: 1,
            prevArrow: $('#new_arrival .btn_prev'),
            nextArrow: $('#new_arrival .btn_next'),
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                      centerPadding: '0',
                    }
                }
              ]
        });
        (async () => {
            await handleRecommendedProducts();
            const $recommendProdSlide = $('#recommend_prod .recommend_prod_slide');
            if ($recommendProdSlide.children().length <=4) {
              $recommendProdSlide.removeClass('is_loading').parents('.container_slider').addClass('no_slide');
              return;
            }
            slickSlider('.recommend_prod_slide', {
              fade: false,
              autoplay: false,
              arrows: true,
              dots: false,
              autoplaySpeed: 3000,
              adaptiveHeight: true,
              variableWidth: true,
              slidesToShow: 1,
              prevArrow: $('#recommend_prod .btn_prev'),
              nextArrow: $('#recommend_prod .btn_next'),
              responsive: [
                {
                  breakpoint: 960,
                  settings: {
                    centerPadding: '0',
                  }
                }
              ]
            });
          })();
  };



    const engine = new liquidjs.Liquid();
// Define Shopify-like filters
engine.registerFilter('money_without_currency', price => {
    return Number(price).toLocaleString();
  });
  
  
  

async function handleRecommendedProducts() {
    try {
      const limit = 4;
      let allHtml = '';
      let data = await Promise.all(
        recommendData.map(id => Product.getRecommendedProducts(id, limit, 'related'))
      );
      data= data.flat();
      data = [...new Map(data.map(item => [item.id, item])).values()];  // remove duplicates by product gid
        const html = await Promise.all(
            data.map(product =>
              engine.renderFile( rcTpl, { product, custom_class: 'slide_item' })
            )
          );
        allHtml = html.join('');

      
  
      // 5️⃣ Inject all rendered HTML into the page
      $('#recommend_prod .recommend_prod_slide').html(allHtml);
    } catch (err) {
      console.error('Error:', err);
    }
  }

  window.onresize = function () {
  };
  window.onscroll = function () {
  };
})(jQuery);
